import { LevelType, SpaceType } from 'data/types';

export type SpaceWithSection = SpaceType & {
  sectionUniqueId: string;
  sizingAttributesChanged?: boolean;
};

export function spacesOnChangedLevels(
  structure: LevelType[],
  changedLevelUniqueIds: readonly string[]
): SpaceWithSection[] {
  const changedIds = new Set(changedLevelUniqueIds);
  const spaces: SpaceWithSection[] = [];

  structure.forEach((level) => {
    if (changedIds.has(level.uniqueId)) {
      level.sections.forEach((section) => {
        section.spaces.forEach((space) => {
          spaces.push({
            ...space,
            sectionUniqueId: section.uniqueId
          });
        });
      });
    }
  });

  return spaces;
}

export function uniqueSpacesById<T extends { uniqueId: string }>(
  spaces: T[]
): T[] {
  const seen = new Set<string>();
  return spaces.filter((space) => {
    if (seen.has(space.uniqueId)) {
      return false;
    }
    seen.add(space.uniqueId);
    return true;
  });
}
